import ProductLoading from './Loading';

export default ProductLoading;
